import "./anexoI1.scss";
import Footer from "../../components/molecules/footer/Footer";
import Header from "../../components/molecules/header/Header";
import DatePicker from "react-datepicker";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import {
    insertSolicitudConcursoAnexoI1,
    obtenerDatosDestino,
    obtenerGrupoCategoriaSituacion,
    obtenerLocalidades,
    obtenerProvincias
} from "../../components/services/ConcursosService";
import Select from "react-select";
import { getDatosIhPersona } from "../../components/services/IhPersonaService";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { getSolicitudPorCodAnexoI1 } from "../../components/services/Anexoi1Service";


const AnexoI1Limpio = () => {
    const params = useParams();
    

    const [user] = useLocalStorage("user", "");

    const [show, setShow] = useState({
        mensaje: false,
    });
    const handleClose = () => {
        setShow(false);
    };

    const [provincias, setProvincias] = useState([]);
    const [provinciasSelect, setProvinciasSelect] = useState([]);
    const [municipios, setMunicipios] = useState([]);

    const [municipiosSelect, setMunicipiosSelect] = useState([]);

    const [grupoCategoriaSituacion] = useState();
    const [grupoProfesionalSelect, setGrupoProfesionalSelect] = useState([]);
    const [categoriaEspecialidadSelect, setCategoriaEspecialidadSelect] = useState([]);
    const [situacionAdministrativa, setSituacionAdministrativa] = useState();
    // const [situacionPorCategoria] = useState({});

    const [datosDestino, setDatosDestino] = useState();
    const [loading, setLoading] = useState(true); // Added loading state
    const [cargaBoton, setCargaBoton] = useState(false); // For button spinner

    const [initialValues, setInitialValues] = useState({
        xSolicitud: -1,
        descripSol: !params?.idsol
            ? `Borrador ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            })}`
            : "",
        datosParticipante: {
            letraInicioDNI: "",
            niep: user?.niep || "",
            letraFinalDNI: user?.letniep || "",
            apellido1: user?.apellido1 || "",
            apellido2: user?.apellido2 || "",
            nombre: user?.nombre || "",
            tlfFijo: "",
            tlfMovil: "",
            correo: "",
            calle: "",
            numCalle: "",
            bis: "N",
            escalera: "",
            piso: "",
            puerta: "",
            cp: "",
            provincia: { id: "", value: "" },
            municipio: "",
            localidad: "",
        },
        datosParticipacion: {
            ordenPreferencia: "",
            grupoProfesional: "",
            obligado: "N",
            categoria: "",
            derecho: "N",
            situacionAdmin: "",
        },
        datosDestino: {
            numPuesto: "",
            codCategoria: "",
            catEsp: "",
            codGrupo: "",
            grupoProfesional: "",
            nivel: "",
            consejeria: "",
            centroDirectivo: "",
            localidad: "",
            caracterOcupacion: "",
            fechaTomaPosesion: "",
        },
        dprovinciafirma: "", // For the signature location
    });


    const validate = (values) => {
        if (!values) return {};
        const errors = {};

        // descripSol
        if (!values.descripSol?.trim()) {
            errors.descripSol = "La descripción de la solicitud es obligatoria.";
        }

        const dp = values.datosParticipante || {};

        // nombre *
        if (!dp.nombre?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.nombre = "El nombre es obligatorio.";
        }

        // teléfono móvil * (antes era fijo)
        if (!dp.tlfMovil?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.tlfMovil = "El teléfono móvil es obligatorio.";
        } else if (!/^\d{9}$/.test(dp.tlfMovil)) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.tlfMovil = "Debe introducir un teléfono móvil válido de 9 dígitos.";
        }

        // correo *
        if (!dp.correo?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.correo = "El correo electrónico es obligatorio.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dp.correo)) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.correo = "Debe introducir un correo electrónico válido.";
        }

        // calle *
        if (!dp.calle?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.calle = "La calle es obligatoria.";
        }

        // número *
        if (!dp.numCalle?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.numCalle = "El número es obligatorio.";
        }

        // CP *
        if (!dp.cp?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.cp = "El código postal es obligatorio.";
        } else if (!/^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/.test(dp.cp)) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.cp = "Debe introducir un Código Postal válido.";
        }

        // provincia *
        if (!dp.provincia?.id) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.provincia = "La provincia es obligatoria.";
        }
        // municipio *
        if (!dp.municipio?.trim()) {
            errors.datosParticipante = errors.datosParticipante || {};
            errors.datosParticipante.municipio = "El municipio es obligatorio.";
        }

        // datosParticipacion
        const dpa = values.datosParticipacion || {};

        // ordenPreferencia *
        if (!dpa.ordenPreferencia?.trim()) {
            errors.datosParticipacion = errors.datosParticipacion || {};
            errors.datosParticipacion.ordenPreferencia = "El orden de preferencia es obligatorio.";
        } else if (!/^\d+$/.test(dpa.ordenPreferencia.trim())) {
            errors.datosParticipacion = errors.datosParticipacion || {};
            errors.datosParticipacion.ordenPreferencia = "El orden de preferencia debe ser numérico.";
        } else if (dpa.ordenPreferencia.trim().length > 4) {
            errors.datosParticipacion = errors.datosParticipacion || {};
            errors.datosParticipacion.ordenPreferencia = "El orden de preferencia no puede tener más de 4 dígitos.";
        } else if (parseInt(dpa.ordenPreferencia.trim(), 10) <= 0) {
            errors.datosParticipacion = errors.datosParticipacion || {};
            errors.datosParticipacion.ordenPreferencia = "El orden de preferencia debe ser mayor que 0.";
        }



        // grupoProfesional *
        if (!dpa.grupoProfesional?.codGrupo?.trim()) {
            errors.datosParticipacion = errors.datosParticipacion || {};
            if (!errors.datosParticipacion.grupoProfesional) {
                errors.datosParticipacion.grupoProfesional = {};
            }
            errors.datosParticipacion.grupoProfesional.codGrupo = "El grupo profesional es obligatorio.";
        }

        // categoria *
        if (!dpa.categoria?.codCategoria) {
            errors.datosParticipacion = errors.datosParticipacion || {};
            if (!errors.datosParticipacion.categoria) {
                errors.datosParticipacion.categoria = {};
            }
            errors.datosParticipacion.categoria.codCategoria = "La categoría/especialidad es obligatoria.";
        }

        return errors;
    };



    // Estado auxiliar para guardar la provincia que viene de IhPersona
    const [provinciaPersona, setProvinciaPersona] = useState(null);

    // Carga de datos personales desde IhPersona
    useEffect(() => {
        const fetchPersona = async () => {
            try {
                const data = await getDatosIhPersona();
                if (!data) return;

                // Tomamos un id de provincia válido
                const idProv =
                    data.loccprovincia || // típico
                    data.locmunprvcprodom || // fallback si el backend lo trae así
                    "";

                if (idProv) setProvinciaPersona(idProv);

                // Precargamos provincia SOLO con id (el label lo completamos luego)
                setInitialValues((prev) => ({
                    ...prev,
                    datosParticipante: {
                        ...prev.datosParticipante,
                        letraInicioDNI: data.letiniiep || "",
                        niep: data.niep || "",
                        letraFinalDNI: data.letfiniep || "",
                        apellido1: data.apellido1 || "",
                        apellido2: data.apellido2 || "",
                        nombre: data.nombre || "",
                        tlfFijo: data.ntelefono?.includes("*") ? "" : data.ntelefono || "",
                        tlfMovil: data.ntfnocor || "",
                        correo: data.cemailcor || data.cemailper || "",
                        calle: data.dcalle || "",
                        numCalle: data.ncalle || "",
                        bis: data.lbis || "N",
                        escalera: data.escalera || "",
                        piso: data.npiso || "",
                        puerta: data.puerta || "",
                        cp: data.cpostal || "",
                        provincia: idProv ? { id: idProv, value: "" } : { id: "", value: "" },
                        municipio: data.locmuncmunicipio || "",
                        localidad: data.locclocalidad || "",
                    },
                }));

                // Cargamos municipios con el id que tengamos
                const provParaLocalidades = data.locmunprvcprodom || idProv;
                if (provParaLocalidades) {
                    const localidadesData = await obtenerLocalidades(provParaLocalidades);
                    setMunicipios(localidadesData);
                    setMunicipiosSelect(
                        localidadesData.map((item) => ({
                            value: `${item?.cmunicipio}-${item?.clocalidad}`,
                            label: item?.dlocalidad,
                        }))
                    );
                }
            } catch (error) {
                // console.error("Error al cargar datos de persona:", error);
                setShow({
                    mensaje: true,
                    content: "Error al cargar los datos del participante.",
                    tipo: "tituloModal rojo",
                });
            }
        };

        fetchPersona();
    }, [setMunicipios]);



    useEffect(() => {
        if (!provinciaPersona || provinciasSelect.length === 0) return;

        const prov = provinciasSelect.find(p => p.value === provinciaPersona);
        if (prov) {
            setInitialValues(prev => ({
                ...prev,
                datosParticipante: {
                    ...prev.datosParticipante,
                    provincia: { id: prov.value, value: prov.label }
                }
            }));
        }
        // 👇 Dependemos solo de provinciaPersona y provinciasSelect
    }, [provinciaPersona, provinciasSelect]);

    
    



    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // 1️⃣ Provincias
                let provs = provincias;
                if (!provs || provs.length === 0) {
                    provs = await obtenerProvincias();
                    setProvincias(provs);
                    setProvinciasSelect(provs.map(p => ({ value: p.id, label: p.value })));
                }

                // 2️⃣ Grupos profesionales
                const respGrupos = await obtenerGrupoCategoriaSituacion(user?.niep);
                const grupos = Array.isArray(respGrupos)
                    ? respGrupos.map(g => ({ value: g.cgrppro, label: g.grppro || g.descripcion || "" }))
                    : respGrupos?.cgrppro
                        ? [{ value: respGrupos.cgrppro, label: respGrupos.grppro || respGrupos.descripcion || "" }]
                        : [];
                setGrupoProfesionalSelect(grupos);

                // 3️⃣ Si estamos editando
                if (params?.idsol) {
                    const s = await getSolicitudPorCodAnexoI1(params?.idsol);
                    

                    // --- Localidades ---
                    let municipiosData = [];
                    if (s.locCprovincia) {
                        municipiosData = await obtenerLocalidades(s.locCprovincia);
                        setMunicipios(municipiosData);
                        setMunicipiosSelect(municipiosData.map(l => ({
                            value: `${l.cmunicipio}-${l.clocalidad}`,
                            label: l.dlocalidad
                        })));
                       
                        
                    }

                    // --- Grupo/Categoría ---
                    const grupoSel = grupos.find(g => g.value === s.cGrupo) || {
                        value: s.cGrupo,
                        label: s.dGrupo || s.cGrupo
                    };
                    const respCats = await obtenerGrupoCategoriaSituacion(user?.niep, s.cGrupo);
                    const categorias = Array.isArray(respCats)
                        ? respCats.map(c => ({ value: c.ccatpro, label: c.especialidad }))
                        : respCats?.ccatpro
                            ? [{ value: respCats.ccatpro, label: respCats.especialidad }]
                            : [];
                    setCategoriaEspecialidadSelect(categorias);

                    // --- Destino ---
                    let destino = null;
                    if (s.cGrupo && s.cCuerpo) {
                        destino = await obtenerDatosDestino(user?.niep, s.cGrupo, s.cCuerpo);
                        if (destino) setDatosDestino(destino);
                    }

                    // --- Actualizamos todo el form ---
                    setInitialValues(prev => ({
                        ...prev,
                        xSolicitud: s.xSolicitud ?? -1,
                        descripSol: s.dSolicitud || prev.descripSol,
                        datosParticipante: {
                            ...prev.datosParticipante,
                            letraInicioDNI: s.letiniiep || "",
                            niep: s.niep || "",
                            letraFinalDNI: s.letfiniep || "",
                            apellido1: s.apellido1 || "",
                            apellido2: s.apellido2 || "",
                            nombre: s.nombre || "",
                            tlfFijo: s.nTelefono || "",
                            tlfMovil: s.nTelefono2 || "",
                            correo: s.tEmail || "",
                            calle: s.dCalle || "",
                            numCalle: s.nCalle || "",
                            bis: s.lBis || "N",
                            escalera: s.escalera || "",
                            piso: s.nPiso || "",
                            puerta: s.puerta || "",
                            cp: s.cPostal || "",
                            provincia: { id: s.locCprovincia || "", value: "" },
                            municipio: s.locCmunicipio || "",
                            localidad: s.locClocalidad || ""
                        },
                        datosParticipacion: {
                            ordenPreferencia: s.nOrden || "",
                            grupoProfesional: { codGrupo: grupoSel.value, grupoProfesional: grupoSel.label },
                            obligado: s.lObligado || "N",
                            categoria: {
                                codCategoria: s.cCuerpo || categorias[0]?.value || "",
                                categoria: s.dCuerpo || categorias[0]?.label || ""
                            },
                            derecho: s.lCondic || "N",
                            situacionAdmin: {
                                codSituacion: s.sitCsituacion || respCats?.situacion || "",
                                situacion: s.dSituacion || respCats?.dsituacion || ""
                            },
                        },
                        datosDestino: destino ? {
                            numPuesto: destino.numPuesto || "",
                            codCategoria: destino.codCategoria || "",
                            catEsp: destino.catEsp || "",
                            codGrupo: destino.codGrupo || "",
                            grupoProfesional: destino.grupoProfesional || "",
                            nivel: destino.nivel || "",
                            consejeria: destino.consejeria || "",
                            centroDirectivo: destino.centroDirectivo || "",
                            localidad: destino.localidad || "",
                            caracterOcupacion: destino.caracterOcupacion || "",
                            fechaTomaPosesion: destino.fechaTomaPosesion ? new Date(destino.fechaTomaPosesion) : ""
                        } : prev.datosDestino,
                        dprovinciafirma: s.dLugfir || ""
                    }));
                }
            } catch (err) {
                // console.error("Error cargando datos iniciales:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [params?.idsol, user?.niep, provincias]);





    useEffect(() => {
        if(municipios.length > 0) {}
        if (datosDestino && !situacionAdministrativa) {
            setSituacionAdministrativa({
                codSituacion: grupoCategoriaSituacion?.situacion,
                situacion: grupoCategoriaSituacion?.dsituacion,
            });
        }
    }, [datosDestino, grupoCategoriaSituacion, situacionAdministrativa,municipios]);

    const formatDate = (date) => {
        const months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ];
        const d = new Date(date);
        const day = d.getUTCDate();
        const month = months[d.getUTCMonth()];
        const year = d.getUTCFullYear();
        return `${day} ${month} ${year}`;
    };

    const handleSubmit = async (values, { setSubmitting, validateForm, setTouched }) => {
        

        // Si no hay errores, continuamos con el envío
        setCargaBoton(true);

        try {
            const payload = {
                xSolicitud: values.xSolicitud,
                descripSol: values.descripSol,
                dprovinciafirma: values.dprovinciafirma,

                // Los tres apartados tal cual
                datosParticipante: values.datosParticipante,
                datosParticipacion: values.datosParticipacion,
                datosDestino: values.datosDestino,

                // Metadatos mínimos
                codconcurso: params?.idcon,
                tipiep: "",
            };

            

            const data = await insertSolicitudConcursoAnexoI1(payload, params?.idcon);
            

            setShow({
                mensaje: true,
                content: data,
                tipo: "tituloModal",
                destinoAviso: data.startsWith("Error:") ? null : `/concurso/${params?.idcon}`,
                destinoCerrar: data.startsWith("Error:") ? null : `/concurso/${params?.idcon}`,
            });
        } catch (error) {
            // console.error("Error al guardar la solicitud:", error);
            setShow({
                mensaje: true,
                content: "Error al guardar la solicitud. Inténtelo de nuevo más tarde.",
                tipo: "tituloModal rojo",
            });
        } finally {
            setCargaBoton(false);
            setSubmitting(false);
        }
    };


    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <Header />
            <div className="container d-flex flex-column min-vh-100 card mt-5" id="inicio" role="main">
                <div className="my-auto">
                    <div className="container-login">
                        <div className="tituloSolicitud">
                            <h2 className="tituloPagina">Anexo I.1</h2>
                            <div className="d-flex align-items-center flex-column">
                                <h3 className="tituloPagina subTituloPagina">SOLICITUD DE PARTICIPACIÓN</h3>
                            </div>
                            <span className="p-3 rojo">Campo obligatorio *</span>

                            <div className="datosPersonales d-flex flex-column">
                                <div className="formulario">
                                    <Formik
                                        initialValues={initialValues}
                                        validate={validate}
                                        onSubmit={handleSubmit}
                                        enableReinitialize={true} // Important for updating initial values on data load
                                    >
                                        {({ values, setFieldValue, errors, touched, setTouched, isSubmitting, setSubmitting, validateForm }) => (
                                            <Form>
                                                {/* {params?.idsol === null || params?.idsol === undefined ? ( */}
                                                <div className="descripcion p-2 d-flex flex-column">
                                                    <label htmlFor="descripSol">
                                                        Descripción de su solicitud
                                                        <span className="rojo"> *</span>:
                                                        <i
                                                            className="fa-regular fa-circle-question ms-2 cursorPointer"
                                                            onClick={() => {
                                                                setShow({
                                                                    mensaje: true,
                                                                    otherContent:
                                                                        'Ponga nombre a su solicitud para poder identificar el fichero electrónico; es texto libre, escriba lo que quiera: p.e. "Concurso 1"',
                                                                    tipo: "tituloModal",
                                                                    destinoCerrar: null,
                                                                    destinoAviso: null,
                                                                });
                                                            }}
                                                        ></i>
                                                    </label>
                                                    <div className="d-flex">
                                                        <Field
                                                            type="text"
                                                            id="descripSol"
                                                            name="descripSol"
                                                            className={`form-control ms-2 ${errors.descripSol && touched.descripSol ? "is-invalid" : ""
                                                                }`}
                                                            placeholder="Descripción de su solicitud"
                                                            maxLength="99"
                                                        />
                                                    </div>
                                                    <ErrorMessage
                                                        name="descripSol"
                                                        component="div"
                                                        className="error rojo pt-2 ps-2"
                                                    />
                                                </div>
                                                {/* ) : (
                                                    <div className="descripcion p-2 d-flex">
                                                        <label htmlFor="descripSol">Descripción de su solicitud :</label>
                                                        <div className="d-flex">
                                                            <p className="fw-bold ps-1"> {values.descripSol}</p>
                                                        </div>
                                                    </div>
                                                )} */}

                                                <div className="infoSolicitud">
                                                    <div className="instrucciones">
                                                        <p className="my-3 mx-2">
                                                            El personal laboral cuyos datos figuran a continuación SOLICITA:
                                                        </p>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="d-flex justify-content-between">
                                                        <div className="subSubTituloSolicitud p-2 fw-bold">
                                                            <h4 className="tituloh4access tituloCard noBg">1. Datos del Participante</h4>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="formularioDatosPesonalesI1 p-2">
                                                    <div className="datosDNIi1 m-1">
                                                        <label htmlFor="niep">DNI o Pasaporte:</label>
                                                        <div className="d-flex">
                                                            <Field
                                                                type="text"
                                                                id="letraInicioDNI"
                                                                name="datosParticipante.letraInicioDNI"
                                                                className="form-control m-1 w-25"
                                                                maxLength="1"
                                                                disabled
                                                            />
                                                            <Field
                                                                type="text"
                                                                id="niep"
                                                                name="datosParticipante.niep"
                                                                className="form-control m-1"
                                                                disabled
                                                            />
                                                            <Field
                                                                type="text"
                                                                id="letraFinalDNI"
                                                                name="datosParticipante.letraFinalDNI"
                                                                className="form-control m-1 w-25"
                                                                maxLength="1"
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="ape1i1 m-2">
                                                        <label htmlFor="apellido1">Primer apellido:</label>
                                                        <Field
                                                            type="text"
                                                            id="apellido1"
                                                            name="datosParticipante.apellido1"
                                                            className="form-control"
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="ape2i1 m-2">
                                                        <label htmlFor="apellido2">Segundo apellido:</label>
                                                        <Field
                                                            type="text"
                                                            id="apellido2"
                                                            name="datosParticipante.apellido2"
                                                            className="form-control"
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="nombrei1 m-2">
                                                        <label htmlFor="nombre">
                                                            Nombre <span className="rojo">*</span>:
                                                        </label>
                                                        <Field
                                                            type="text"
                                                            id="nombre"
                                                            name="datosParticipante.nombre"
                                                            className={`form-control ${errors.datosParticipante?.nombre && touched.datosParticipante?.nombre
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            maxLength="29"
                                                            readOnly
                                                            disabled
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipante.nombre"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="tlfFijoi1 m-2">
                                                        <label htmlFor="tlfFijo">
                                                            Teléfono fijo:
                                                        </label>
                                                        <Field
                                                            type="text"
                                                            id="tlfFijo"
                                                            name="datosParticipante.tlfFijo"
                                                            className={`form-control ${errors.datosParticipante?.tlfFijo && touched.datosParticipante?.tlfFijo
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                        />
                                                    </div>
                                                    <div className="tlfMovili1 m-2">
                                                        <label htmlFor="tlfMovil">Teléfono móvil<span className="rojo"> *</span>:</label>
                                                        <Field
                                                            type="text"
                                                            id="tlfMovil"
                                                            name="datosParticipante.tlfMovil"
                                                            className={`form-control ${errors.datosParticipante?.tlfMovil && touched.datosParticipante?.tlfMovil
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                                

                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipante.tlfMovil"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="emaili1 m-2">
                                                        <label htmlFor="correo">
                                                            Correo electrónico <span className="rojo">*</span>:
                                                        </label>
                                                        <Field
                                                            type="email"
                                                            id="correo"
                                                            name="datosParticipante.correo"
                                                            className={`form-control ${errors.datosParticipante?.correo && touched.datosParticipante?.correo
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            maxLength="79"
                                                            readOnly
                                                            disabled
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipante.correo"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="viai1 m-2">
                                                        <label htmlFor="calle">
                                                            Calle <span className="rojo">*</span>:
                                                        </label>
                                                        <Field
                                                            type="text"
                                                            id="calle"
                                                            name="datosParticipante.calle"
                                                            className={`form-control ${errors.datosParticipante?.calle && touched.datosParticipante?.calle
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            maxLength="79"
                                                             readOnly
                                                            disabled
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipante.calle"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="numeroBisi1 m-2">
                                                        <div className="numero">
                                                            <label htmlFor="numCalle">
                                                                Nº <span className="rojo">*</span>:
                                                            </label>
                                                            <Field
                                                                type="text"
                                                                id="numCalle"
                                                                name="datosParticipante.numCalle"
                                                                className={`form-control ${errors.datosParticipante?.numCalle && touched.datosParticipante?.numCalle
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                maxLength="5"
                                                                readOnly
                                                            disabled                                                            />
                                                        </div>
                                                        <div className="bis d-flex align-items-center justify-content-center">
                                                            <label htmlFor="bis">Bis:</label>{" "}
                                                            <Field
                                                                type="checkbox"
                                                                id="bis"
                                                                name="datosParticipante.bis"
                                                                className="form-check-input checkBis"
                                                                title="Bis"
                                                                aria-label="Bis"
                                                                value="S"
                                                                checked={values.datosParticipante.bis === "S"}
                                                                onChange={(e) =>
                                                                    setFieldValue(
                                                                        "datosParticipante.bis",
                                                                        e.target.checked ? "S" : "N"
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                        <div className="mensajeNumeroBis">
                                                            <ErrorMessage
                                                                name="datosParticipante.numCalle"
                                                                component="div"
                                                                className="error rojo pt-2"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="escalerai1 m-2">
                                                        <label htmlFor="escalera">Escalera:</label>
                                                        <Field
                                                            type="text"
                                                            id="escalera"
                                                            name="datosParticipante.escalera"
                                                            className="form-control"
                                                            maxLength="5"
                                                            readOnly
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="pisoi1 m-2">
                                                        <label htmlFor="piso">Piso:</label>
                                                        <Field
                                                            type="text"
                                                            id="piso"
                                                            name="datosParticipante.piso"
                                                            className="form-control"
                                                            maxLength="5"
                                                            readOnly
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="puertai1 m-2">
                                                        <label htmlFor="puerta">Puerta:</label>
                                                        <Field
                                                            type="text"
                                                            id="puerta"
                                                            name="datosParticipante.puerta"
                                                            className="form-control"
                                                            maxLength="5"
                                                            readOnly
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className="cpi1 m-2">
                                                        <label htmlFor="cp">
                                                            CP <span className="rojo">*</span>:
                                                        </label>
                                                        <Field
                                                            type="text"
                                                            id="cp"
                                                            name="datosParticipante.cp"
                                                            className={`form-control ${errors.datosParticipante?.cp && touched.datosParticipante?.cp
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                                readOnly
                                                            disabled
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipante.cp"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="localidad m-2">
                                                        <label htmlFor="municipio">
                                                            Municipio <span className="rojo">*</span>:
                                                        </label>
                                                        <Select
                                                            options={municipiosSelect}
                                                            value={
                                                                values.datosParticipante.municipio && values.datosParticipante.localidad
                                                                    ? municipiosSelect.find(
                                                                        (m) =>
                                                                            m.value === `${values.datosParticipante.municipio}-${values.datosParticipante.localidad}`
                                                                    )
                                                                    : null
                                                            }
                                                            onChange={(selectedOption) => {
                                                                if (selectedOption) {
                                                                    const [mun, loc] = selectedOption.value.split("-");
                                                                    setFieldValue("datosParticipante.municipio", mun);
                                                                    setFieldValue("datosParticipante.localidad", loc);
                                                                } else {
                                                                    setFieldValue("datosParticipante.municipio", "");
                                                                    setFieldValue("datosParticipante.localidad", "");
                                                                }
                                                            }}
                                                            className={`${errors.datosParticipante?.municipio && touched.datosParticipante?.municipio
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                                readOnly
                                                            disabled
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipante.municipio"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="provincia m-2">
                                                        <label htmlFor="datosParticipante.provincia">
                                                            Provincia <span className="rojo">*</span>:
                                                        </label>
                                                        <Select
                                                            name="datosParticipante.provincia"
                                                            className={`${errors.datosParticipante?.provincia && touched.datosParticipante?.provincia
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            placeholder="Selecciona provincia"
                                                            options={provinciasSelect}
                                                            value={
                                                                values.datosParticipante.provincia?.id
                                                                    ? {
                                                                        value: values.datosParticipante.provincia.id,
                                                                        label:
                                                                            values.datosParticipante.provincia.value ||
                                                                            provinciasSelect.find(p => p.value === values.datosParticipante.provincia.id)?.label ||
                                                                            ""
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={async (selected) => {
                                                                const idProv = selected?.value || "";

                                                                // 👇 Actualiza valores del formulario
                                                                setFieldValue("datosParticipante.provincia.id", idProv);
                                                                setFieldValue("datosParticipante.provincia.value", selected?.label || "");

                                                                // 👇 Reinicia municipio y localidad
                                                                // 👉 Reset municipio y localidad ANTES de recargar opciones
                                                                setFieldValue("datosParticipante.municipio", "");
                                                                setFieldValue("datosParticipante.localidad", "");
                                                                // 👉 También puedes limpiar el estado del select directamente
                                                                setMunicipiosSelect([]);

                                                                // 👇 Vuelve a cargar municipios para la nueva provincia
                                                                if (idProv) {
                                                                    try {
                                                                        const locs = await obtenerLocalidades(idProv);
                                                                        setMunicipios(locs);
                                                                        setMunicipiosSelect(
                                                                            locs.map(l => ({
                                                                                value: `${l.cmunicipio}-${l.clocalidad}`,
                                                                                label: l.dlocalidad
                                                                            }))
                                                                        );
                                                                    } catch (err) {
                                                                        // console.error("Error al cargar municipios de la provincia:", err);
                                                                    }
                                                                } else {
                                                                    setMunicipios([]);
                                                                    setMunicipiosSelect([]);
                                                                }
                                                            }}
                                                            readOnly
                                                            disabled
                                                        />





                                                        <ErrorMessage
                                                            name="datosParticipante.provincia"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="subSubTituloSolicitud p-2 fw-bold">
                                                    <h4 className="tituloh4access tituloCard noBg">2. Datos de participación</h4>
                                                </div>
                                                <div className="datosParticipacion">
                                                    <div className="ordenPref m-2">
                                                        <label htmlFor="ordenPreferencia">
                                                            Orden de preferencia de la solicitud <span className="rojo">*</span>:
                                                        </label>
                                                        <Field
                                                            type="text"
                                                            id="ordenPreferencia"
                                                            name="datosParticipacion.ordenPreferencia"
                                                            className={`form-control ${errors.datosParticipacion?.ordenPreferencia &&
                                                                touched.datosParticipacion?.ordenPreferencia
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                                maxLength="4"
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipacion.ordenPreferencia"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>
                                                    <div className="grupoProf m-2">
                                                        <label htmlFor="grupoProfesional">Grupo profesional <span className="rojo">*</span>:</label>
                                                        <Select
                                                            placeholder="Selecciona una opción"
                                                            id="grupoProfesional"
                                                            name="datosParticipacion.grupoProfesional"
                                                            options={grupoProfesionalSelect}   // [{value,label}]
                                                            value={
                                                                values.datosParticipacion.grupoProfesional?.codGrupo
                                                                    ? {
                                                                        value: values.datosParticipacion.grupoProfesional.codGrupo,
                                                                        label: values.datosParticipacion.grupoProfesional.grupoProfesional,
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={async (option) => {
                                                                // ✅ Actualizar grupo en Formik
                                                                setFieldValue("datosParticipacion.grupoProfesional", {
                                                                    codGrupo: option?.value || "",
                                                                    grupoProfesional: option?.label || "",
                                                                });

                                                                // ✅ Resetear campos dependientes
                                                                setFieldValue("datosParticipacion.categoria", { codCategoria: "", categoria: "" });
                                                                setFieldValue("datosParticipacion.situacionAdmin", { codSituacion: "", situacion: "" });
                                                                setCategoriaEspecialidadSelect([]);
                                                                setSituacionAdministrativa(null);
                                                                setDatosDestino(null);

                                                                if (option?.value) {
                                                                    try {
                                                                        const resp = await obtenerGrupoCategoriaSituacion(user?.niep, option.value);
                                                                        const categorias = Array.isArray(resp)
                                                                            ? resp.map(c => ({ value: c.ccatpro, label: c.especialidad }))
                                                                            : resp?.ccatpro
                                                                                ? [{ value: resp.ccatpro, label: resp.especialidad }]
                                                                                : [];

                                                                        setCategoriaEspecialidadSelect(categorias);

                                                                        // Si solo hay una categoría, la preseleccionamos y cargamos destino/situación
                                                                        if (categorias.length === 1) {
                                                                            const unica = categorias[0];
                                                                            setFieldValue("datosParticipacion.categoria", {
                                                                                codCategoria: unica.value,
                                                                                categoria: unica.label,
                                                                            });

                                                                            if (resp?.situacion || resp?.dsituacion) {
                                                                                const sit = {
                                                                                    codSituacion: resp.situacion || "",
                                                                                    situacion: resp.dsituacion || "",
                                                                                };
                                                                                setFieldValue("datosParticipacion.situacionAdmin", sit);
                                                                                setSituacionAdministrativa(sit);
                                                                            }

                                                                            const destino = await obtenerDatosDestino(user?.niep, option.value, unica.value);
                                                                            if (destino) {
                                                                                setDatosDestino(destino);
                                                                                setFieldValue("datosDestino", {
                                                                                    numPuesto: destino.numPuesto || "",
                                                                                    codCategoria: destino.codCategoria || "",
                                                                                    catEsp: destino.catEsp || "",
                                                                                    codGrupo: destino.codGrupo || "",
                                                                                    grupoProfesional: destino.grupoProfesional || "",
                                                                                    nivel: destino.nivel || "",
                                                                                    consejeria: destino.consejeria || "",
                                                                                    centroDirectivo: destino.centroDirectivo || "",
                                                                                    localidad: destino.localidad || "",
                                                                                    caracterOcupacion: destino.caracterOcupacion || "",
                                                                                    fechaTomaPosesion: destino.fechaTomaPosesion
                                                                                        ? new Date(destino.fechaTomaPosesion)
                                                                                        : "",
                                                                                });
                                                                            }
                                                                        }
                                                                    } catch (err) {
                                                                        // console.error("Error cargando categorías para el grupo:", err);
                                                                    }
                                                                }
                                                            }}
                                                            className={`${errors.datosParticipacion?.grupoProfesional && touched.datosParticipacion?.grupoProfesional
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipacion.grupoProfesional.codGrupo"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>


                                                    <div className="obliga m-2 d-flex justify-content-between flex-column">
                                                        <div className="checkGrid">
                                                            <div className="checkTit">
                                                                <label htmlFor="obligado">¿Está obligado a concursar?:</label>
                                                            </div>
                                                            <div className="checkOpc1">
                                                                <div className="form-check">
                                                                    <Field
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="datosParticipacion.obligado"
                                                                        id="obligaSi"
                                                                        title="Obligado a concursar"
                                                                        aria-label="Obligado a concursar"
                                                                        value="S"
                                                                        checked={values.datosParticipacion.obligado === "S"}
                                                                        onChange={() => setFieldValue("datosParticipacion.obligado", "S")}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="obligaSi">
                                                                        Si
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="checkOpc2">
                                                                <div className="form-check">
                                                                    <Field
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="datosParticipacion.obligado"
                                                                        id="obligaNo"
                                                                        title="Obligado a concursar"
                                                                        aria-label="Obligado a concursar"
                                                                        value="N"
                                                                        checked={values.datosParticipacion.obligado === "N"}
                                                                        onChange={() => setFieldValue("datosParticipacion.obligado", "N")}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="obligaNo">
                                                                        No
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="categoria m-2">
                                                        <label htmlFor="categoria">Categoría <span className="rojo">*</span>:</label>
                                                        <Select
                                                            id="categoria"
                                                            name="datosParticipacion.categoria"

                                                            options={categoriaEspecialidadSelect} // [{value,label}]
                                                            value={
                                                                values.datosParticipacion.categoria?.codCategoria
                                                                    ? {
                                                                        value: values.datosParticipacion.categoria.codCategoria,
                                                                        label: values.datosParticipacion.categoria.categoria,
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={async (option) => {
                                                                setFieldValue("datosParticipacion.categoria", {
                                                                    codCategoria: option?.value || "",
                                                                    categoria: option?.label || "",
                                                                });

                                                                // Resetear destino y situación para la nueva categoría
                                                                setDatosDestino(null);
                                                                setSituacionAdministrativa(null);
                                                                setFieldValue("datosParticipacion.situacionAdmin", { codSituacion: "", situacion: "" });
                                                                setFieldValue("datosDestino", {
                                                                    numPuesto: "",
                                                                    codCategoria: "",
                                                                    catEsp: "",
                                                                    codGrupo: "",
                                                                    grupoProfesional: "",
                                                                    nivel: "",
                                                                    consejeria: "",
                                                                    centroDirectivo: "",
                                                                    localidad: "",
                                                                    caracterOcupacion: "",
                                                                    fechaTomaPosesion: "",
                                                                });

                                                                if (option?.value && values.datosParticipacion.grupoProfesional?.codGrupo) {
                                                                    try {
                                                                        const destino = await obtenerDatosDestino(
                                                                            user?.niep,
                                                                            values.datosParticipacion.grupoProfesional.codGrupo,
                                                                            option.value
                                                                        );

                                                                        if (destino) {
                                                                            setDatosDestino(destino);
                                                                            setFieldValue("datosDestino", {
                                                                                numPuesto: destino.numPuesto || "",
                                                                                codCategoria: destino.codCategoria || "",
                                                                                catEsp: destino.catEsp || "",
                                                                                codGrupo: destino.codGrupo || "",
                                                                                grupoProfesional: destino.grupoProfesional || "",
                                                                                nivel: destino.nivel || "",
                                                                                consejeria: destino.consejeria || "",
                                                                                centroDirectivo: destino.centroDirectivo || "",
                                                                                localidad: destino.localidad || "",
                                                                                caracterOcupacion: destino.caracterOcupacion || "",
                                                                                fechaTomaPosesion: destino.fechaTomaPosesion
                                                                                    ? new Date(destino.fechaTomaPosesion)
                                                                                    : "",
                                                                            });
                                                                        }

                                                                        if (destino?.situacion || destino?.dsituacion) {
                                                                            const sit = {
                                                                                codSituacion: destino.situacion || "",
                                                                                situacion: destino.dsituacion || "",
                                                                            };
                                                                            setSituacionAdministrativa(sit);
                                                                            setFieldValue("datosParticipacion.situacionAdmin", sit);
                                                                        }
                                                                    } catch (err) {
                                                                        // console.error("Error cargando destino para la categoría:", err);
                                                                    }
                                                                }
                                                            }}
                                                            className={`${errors.datosParticipacion?.categoria && touched.datosParticipacion?.categoria
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipacion.categoria.codCategoria"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div> */}
                                                    <div className="categoria m-2">
                                                        <label htmlFor="categoria">Categoría <span className="rojo">*</span>:</label>
                                                        <Select
                                                            placeholder="Selecciona una opción"
                                                            id="categoria"
                                                            name="datosParticipacion.categoria"
                                                            options={categoriaEspecialidadSelect} // [{value,label}]
                                                            value={
                                                                values.datosParticipacion.categoria?.codCategoria
                                                                    ? {
                                                                        value: values.datosParticipacion.categoria.codCategoria,
                                                                        label: values.datosParticipacion.categoria.categoria,
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={async (option) => {
                                                                setFieldValue("datosParticipacion.categoria", {
                                                                    codCategoria: option?.value || "",
                                                                    categoria: option?.label || "",
                                                                });

                                                                // Resetear destino y situación para la nueva categoría
                                                                setDatosDestino(null);
                                                                setSituacionAdministrativa(null);
                                                                // setFieldValue("datosParticipacion.situacionAdmin", { codSituacion: "", situacion: "" });
                                                                // setFieldValue("datosDestino", {
                                                                //     numPuesto: "",
                                                                //     codCategoria: "",
                                                                //     catEsp: "",
                                                                //     codGrupo: "",
                                                                //     grupoProfesional: "",
                                                                //     nivel: "",
                                                                //     consejeria: "",
                                                                //     centroDirectivo: "",
                                                                //     localidad: "",
                                                                //     caracterOcupacion: "",
                                                                //     fechaTomaPosesion: "",
                                                                // });

                                                                if (option?.value && values.datosParticipacion.grupoProfesional?.codGrupo) {
                                                                    try {
                                                                        const destino = await obtenerDatosDestino(
                                                                            user?.niep,
                                                                            values.datosParticipacion.grupoProfesional.codGrupo,
                                                                            option.value
                                                                        );

                                                                        if (destino) {
                                                                            setDatosDestino(destino);
                                                                            setFieldValue("datosDestino", {
                                                                                numPuesto: destino.numPuesto || "",
                                                                                codCategoria: destino.codCategoria || "",
                                                                                catEsp: destino.catEsp || "",
                                                                                codGrupo: destino.codGrupo || "",
                                                                                grupoProfesional: destino.grupoProfesional || "",
                                                                                nivel: destino.nivel || "",
                                                                                consejeria: destino.consejeria || "",
                                                                                centroDirectivo: destino.centroDirectivo || "",
                                                                                localidad: destino.localidad || "",
                                                                                caracterOcupacion: destino.caracterOcupacion || "",
                                                                                fechaTomaPosesion: destino.fechaTomaPosesion
                                                                                    ? new Date(destino.fechaTomaPosesion)
                                                                                    : "",
                                                                            });
                                                                        }

                                                                        if (destino?.situacion || destino?.dsituacion) {
                                                                            const sit = {
                                                                                codSituacion: destino.situacion || "",
                                                                                situacion: destino.dsituacion || "",
                                                                            };
                                                                            setSituacionAdministrativa(sit);
                                                                            setFieldValue("datosParticipacion.situacionAdmin", sit);
                                                                        }
                                                                    } catch (err) {
                                                                        // console.error("Error cargando destino para la categoría:", err);
                                                                    }
                                                                }
                                                            }}
                                                            className={`${errors.datosParticipacion?.categoria && touched.datosParticipacion?.categoria
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                        />
                                                        <ErrorMessage
                                                            name="datosParticipacion.categoria.codCategoria"
                                                            component="div"
                                                            className="error rojo pt-2"
                                                        />
                                                    </div>

                                                    <div className="derecho m-2 d-flex justify-content-between flex-column">
                                                        <div className="checkGrid">
                                                            <div className="checkTit">
                                                                <label htmlFor="derecho">¿Derecho preferente?:</label>
                                                            </div>
                                                            <div className="checkOpc1">
                                                                <div className="form-check">
                                                                    <Field
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="datosParticipacion.derecho"
                                                                        id="derechoSi"
                                                                        title="Tiene derecho preferente"
                                                                        aria-label="Tiene derecho preferente"
                                                                        value="S"
                                                                        checked={values.datosParticipacion.derecho === "S"}
                                                                        onChange={() => setFieldValue("datosParticipacion.derecho", "S")}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="derechoSi">
                                                                        Si
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="checkOpc2">
                                                                <div className="form-check">
                                                                    <Field
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="datosParticipacion.derecho"
                                                                        id="derechoNo"
                                                                        title="Tiene derecho preferente"
                                                                        aria-label="Tiene derecho preferente"
                                                                        value="N"
                                                                        checked={values.datosParticipacion.derecho === "N"}
                                                                        onChange={() => setFieldValue("datosParticipacion.derecho", "N")}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="derechoNo">
                                                                        No
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="sitAdmin m-2">
                                                        <label htmlFor="situacionAdmin">Situación administrativa:</label>
                                                        <Field
                                                            type="text"
                                                            id="situacionAdmin"
                                                            name="datosParticipacion.situacionAdmin.situacion"
                                                            className="form-control"
                                                            placeholder="Situación administrativa"
                                                            value={values.datosParticipacion?.situacionAdmin?.situacion || ""}
                                                            readOnly
                                                            disabled
                                                        />


                                                    </div>
                                                </div>

                                                <div className="subSubTituloSolicitud p-2 fw-bold">
                                                    <h4 className="tituloh4access tituloCard noBg">3. Datos del Destino Actual</h4>
                                                </div>
                                                <div className="datosDestino">
                                                    <div className="codPuestoda m-2">
                                                        <label htmlFor="numPuesto">Nº cod. puesto:</label>
                                                        <Field
                                                            type="text"
                                                            id="numPuesto"
                                                            name="datosDestino.numPuesto"
                                                            className="form-control"
                                                            placeholder="Nº cod. puesto"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="categoriaDA m-2">
                                                        <label htmlFor="catEsp">Categoría/Especialidad:</label>
                                                        <Field
                                                            type="text"
                                                            id="catEsp"
                                                            name="datosDestino.catEsp"
                                                            className="form-control"
                                                            placeholder="Categoría/Especialidad"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="grupoProfDA m-2">
                                                        <label htmlFor="grupoProfesionalDA">Grupo profesional:</label>
                                                        <Field
                                                            type="text"
                                                            id="grupoProfesionalDA"
                                                            name="datosDestino.grupoProfesional"
                                                            className="form-control"
                                                            disabled
                                                            placeholder="Grupo Profesional"
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="nivelDA m-2">
                                                        <label htmlFor="nivel">Nivel:</label>
                                                        <Field
                                                            type="text"
                                                            id="nivel"
                                                            name="datosDestino.nivel"
                                                            className="form-control"
                                                            placeholder="Nivel"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="consejeriaDA m-2">
                                                        <label htmlFor="consejeria">Consejería:</label>
                                                        <Field
                                                            type="text"
                                                            id="consejeria"
                                                            name="datosDestino.consejeria"
                                                            className="form-control"
                                                            placeholder="Consejería"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="centroDirectivoda m-2">
                                                        <label htmlFor="centroDirectivo">Centro directivo:</label>
                                                        <Field
                                                            type="text"
                                                            id="centroDirectivo"
                                                            name="datosDestino.centroDirectivo"
                                                            className="form-control"
                                                            placeholder="Centro Directivo"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="localidadDA m-2">
                                                        <label htmlFor="localidadDA">Localidad:</label>
                                                        <Field
                                                            type="text"
                                                            id="localidadDA"
                                                            name="datosDestino.localidad"
                                                            className="form-control"
                                                            placeholder="Localidad"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="caracterDA m-2">
                                                        <label htmlFor="caracterOcupacion">Caracter de la ocupación:</label>
                                                        <Field
                                                            type="text"
                                                            id="caracterOcupacion"
                                                            name="datosDestino.caracterOcupacion"
                                                            className="form-control"
                                                            placeholder="Caracter de la Ocupación"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="fechaDA m-2">
                                                        <label htmlFor="fechaTomaPosesion">Fecha Toma de posesión:</label>
                                                        <DatePicker
                                                            selected={
                                                                values.datosDestino.fechaTomaPosesion
                                                                    ? new Date(values.datosDestino.fechaTomaPosesion)
                                                                    : null
                                                            }
                                                            onChange={(date) => setFieldValue("datosDestino.fechaTomaPosesion", date)}
                                                            name="datosDestino.fechaTomaPosesion"
                                                            id="fechaTomaPosesion"
                                                            className="form-control"
                                                            dateFormat="dd/MM/yyyy"
                                                            locale="es"
                                                            disabled
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="lugarFechaFirma">
                                                    <div className="subSubTituloSolicitud p-2 fw-bold">
                                                        <h4 className="tituloh4access tituloCard noBg">Lugar, Fecha y Firma</h4>
                                                    </div>
                                                    <div className="infoFirma">
                                                        <p className="ms-2 mb-5">
                                                            El abajo firmante declara, bajo su expresa responsabilidad, ser ciertos
                                                            cuantos datos figuran en la presente solicitud.
                                                        </p>
                                                        <div className="row mb-5 d-flex justify-content-center align-items-center">
                                                            <div className="col-md-1"><p className="text-center">En </p></div>

                                                            <div className="lugarFirma col-md-3 pb-3">
                                                                <Field
                                                                    type="text"
                                                                    id="dprovinciafirma"
                                                                    name="dprovinciafirma"
                                                                    className="form-control"
                                                                    maxLength="199"
                                                                />
                                                            </div>
                                                            <div className="col-md-3"><p className="text-center">, a {formatDate(new Date())}</p></div>

                                                        </div>
                                                        <div className="nombrefirma d-flex justify-content-center">
                                                            <p className="fw-bold">
                                                                Fdo.: {values.datosParticipante.nombre} {values.datosParticipante.apellido1}{" "}
                                                                {values.datosParticipante.apellido2}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="footer p-2">
                                                    <p>
                                                        En cumplimiento de lo dispuesto en la Ley Orgánica 15/1999, de 13 de
                                                        diciembre, de Protección de Datos de Carácter Personal, la Consejería de
                                                        Hacienda y Administración Pública le informa que sus datos personales
                                                        obtenidos mediante la cumplimentación de este
                                                        documento/impreso/formulario y demás que se adjunten van a ser
                                                        incorporados, para su tratamiento, en un fichero automatizado que
                                                        tratará los datos de todos los participantes en la convocación conforme
                                                        al procedimiento establecido en la misma. De acuerdo con lo previsto en
                                                        la citada Ley Orgánica, pude ejercitar los derechos de acceso,
                                                        rectificación o cancelación y oposición ante el órgano correspondiente.
                                                    </p>
                                                    <p>
                                                        (1) Si posee más de una categoría / especialidad y va a participar por
                                                        más de una de ellas, deberá usar este campo para indicar el orden de
                                                        preferencia de esta solicitud entre todas las que presente para esta
                                                        convocatoria.
                                                    </p>
                                                </div>

                                                <div className="d-flex justify-content-center gap-3 mt-4 row">
                                                    {/* Botón Cancelar */}
                                                    <div className="col-md-5 col-12 order-2 order-md-1">
                                                        <button
                                                            type="button"
                                                            className="btnRed rounded botonVolverAnexoI1"
                                                            onClick={() =>
                                                                setShow({
                                                                    mensaje: true,
                                                                    content: "¿Deseas cancelar el formulario?",
                                                                    tipo: "tituloModal",
                                                                    aviso: true,
                                                                    destinoAviso: `/concurso/${params?.idcon}`,
                                                                })
                                                            }
                                                        >
                                                            <i className="fa-solid fa-rotate-left"></i> Volver
                                                        </button>
                                                    </div>

                                                    {/* Botón Guardar borrador */}
                                                    <div className="col-md-5 col-12 order-1 order-md-2">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary botonGuardarAnexoI1"
                                                            disabled={cargaBoton}
                                                            onClick={async () => {
                                                                // ✅ Ejecuta la validación forzada
                                                                const currentErrors = await validateForm();

                                                                

                                                                // Si hay errores, muestra modal y marca campos como tocados
                                                                if (Object.keys(currentErrors).length > 0) {
                                                                    setTouched({
                                                                        descripSol: true,
                                                                        datosParticipante: {
                                                                            nombre: true,
                                                                            tlfMovil: true,
                                                                            correo: true,
                                                                            calle: true,
                                                                            numCalle: true,
                                                                            cp: true,
                                                                            provincia: true,
                                                                            municipio: true,
                                                                        },
                                                                        datosParticipacion: {
                                                                            ordenPreferencia: true,
                                                                            grupoProfesional: { codGrupo: true },
                                                                            categoria: { codCategoria: true },
                                                                        },
                                                                    });

                                                                    setSubmitting(false);
                                                                    setShow({
                                                                        mensaje: true,
                                                                        content: "Por favor, indica los valores obligatorios antes de guardar.",
                                                                        tipo: "tituloModal",
                                                                        destinoCerrar: null,
                                                                        destinoAviso: null
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            {cargaBoton ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                    Guardando...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="fa-solid fa-save"></i> Guardar
                                                                </>
                                                            )}
                                                        </button>

                                                    </div>




                                                </div>

                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >

            <Footer />
            {
                show.mensaje && (
                    <ModalMensajes
                        show={show.mensaje}
                        handleClose={handleClose}
                        texto={show.content}
                        tipo={show.tipo}
                        aviso={show.aviso}
                        destinoAviso={show.destinoAviso}
                        otherContent={show.otherContent}
                        destinoCerrar={show?.destinoCerrar}
                    />
                )
            }
        </>
    );
};

export default AnexoI1Limpio;